import { useState } from "react"
import styles from "./BetLock.module.css"
import LockDynamicMarketModal from '../lockDynamicMarketModal/index'

export default function BetLock({ sportId, matchId, marketId, marketName }) {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <>
      <div className={styles.container}>
        <div className={styles.betLockWrapper}>
          <button
            className={styles.betLockButton}
            onClick={() => setModalOpen(true)}
          >
            Bet Lock
          </button>
        </div>

        <button className={styles.userBookButton}>User Book</button>
      </div>

      {modalOpen && (
        <LockDynamicMarketModal 
            onClose={() => setModalOpen(false)} 
            sportId={sportId}
            matchId={matchId}
            marketId={marketId}
            marketName={marketName}
        />
      )}
    </>
  )
}
